"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Earfcn = exports.TrackingAreaCode = exports.CellId = void 0;
const effect_1 = require("effect");
const binary_1 = require("../../binary");
const NAMESPACE = 'Network.Cellular.Lte';
exports.CellId = effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 268_435_455)).annotations({
    identifier: `${NAMESPACE}.CellId`,
});
exports.TrackingAreaCode = binary_1.Uint16.annotations({
    identifier: `${NAMESPACE}.TrackingAreaCode`,
});
exports.Earfcn = binary_1.Uint16.annotations({
    identifier: `${NAMESPACE}.Earfcn`,
    description: 'E-UTRA Absolute Radio Frequency Channel Number',
});
//# sourceMappingURL=lte.js.map